module.exports = __webpack_public_path__ + "static/PlatformHero-3ecff18c3dfd7ef85fb0b75960bc66c5.png";